import React from 'react';
import { 
	func, 
	object,
	bool
} from 'prop-types';
import Presenter from './Presenter';
import SamplePresenter from './SamplePresenter';
import Container from './Container';

const QuizContent = ({
	recipe,
	answers,
	onSubmit,
	onDiscard,
	isSample=false,
	...props
}) =>{
	return <Container 
		key={recipe}
		recipe={recipe}
		answers={answers}
		onSubmit={onSubmit}
		onDiscard={onDiscard}
		isSample={isSample}
		render={({
			quizContentProps,
			quizResultProps,
			showResult
		})=>{
			return isSample ? <SamplePresenter 
				{...props}
				key={quizContentProps}
				quizContentProps={quizContentProps}
				quizResultProps={quizResultProps}
			/> :
				<Presenter 
					{...props}
					key={quizContentProps}
					quizContentProps={quizContentProps}
					quizResultProps={quizResultProps}
					showResult={showResult}
				/>;
		}}
	/>;
};

QuizContent.propTypes = {
	recipe : object,
	answers : object,
	onSubmit : func,
	onDiscard : func,
	isSample : bool
};

export default QuizContent;